export default __webpack_public_path__ + "static/media/image.ravana-aviation-academy.55fcf732.png";